module.exports = __webpack_public_path__ + "static/media/uploadImage.26785fb0.svg";